import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import callBanner from './adriver';
import { useBridgeState } from '../../bridge';

const mapStateToProps = state => {
  return {
    isBlockerDetected: state.blockerDetector.isDetected
  };
};

const Banner = ({
  containerId,
  containerClassName,
  tagName,
  sid,
  bn,
  arCn,
  isBlockerDetected,
  target
}) => {
  const { isWebView } = useBridgeState();
  const router = useRouter();
  const tag = tagName || 'div';

  if (isWebView) {
    return null;
  }

  useEffect(() => {
    const bannerRefreshHandler = currentPath => {
      if (currentPath === '/' && !isBlockerDetected)
        callBanner(containerId, sid, bn, arCn, target);
      else window.adriverExtentionLoad(0, null, containerId);
    };

    if (!isBlockerDetected) callBanner(containerId, sid, bn, arCn, target);
    else window.adriverExtentionLoad(0, null, containerId);

    router.events.on('routeChangeComplete', bannerRefreshHandler);

    return () => {
      router.events.off('routeChangeComplete', bannerRefreshHandler);
    };
  }, []);

  return React.createElement(
    tag,
    { id: containerId, className: containerClassName },
    null
  );
};

Banner.propTypes = {
  sid: PropTypes.string,
  bn: PropTypes.string,
  containerId: PropTypes.string,
  containerClassName: PropTypes.string,
  tagName: PropTypes.string,
  target: PropTypes.object,
  arCn: PropTypes.number,
  isBlockerDetected: PropTypes.bool
};

export default connect(mapStateToProps)(Banner);
